"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteNewsRequest = void 0;
var DeleteNewsRequest = /** @class */ (function () {
    function DeleteNewsRequest() {
    }
    return DeleteNewsRequest;
}());
exports.DeleteNewsRequest = DeleteNewsRequest;
;
//# sourceMappingURL=deleteNews.request.js.map